export const UNLOCK_DEVICE_CANCEL_NO = 'No, continue';
export const UNLOCK_DEVICE_CANCEL_YES = 'Yes, cancel';
export const UNLOCK_DEVICE_CANCEL_TITLE =
  'Are you sure you want to cancel the order?';
export const UNLOCK_DEVICE_CANCEL_SUBTITLE =
  'This action is irreversible, the order will be cancelled.';

export const PAPER_HEIGHT = '250px';
export const PAPER_WIDTH = '600px';
